import * as React from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { notification, Modal, Input } from "antd";
import { request } from "../../../services/cpln";
import { ConsoleContext } from "../../../mobxStores/consoleContext/consoleContext";
import { NGButton } from "../../../newcomponents/button/Button";
import { MarketplaceReleaseInstance } from "../types/release";
import { getMarketplaceErrorMessage } from "../utils";

interface Props {
  release: MarketplaceReleaseInstance;
  onClose: any;
  onDone: any;
}

const ReleaseUninstallModalRaw: React.FC<Props> = ({ release, onClose, onDone }) => {
  const navigate = useNavigate();

  const [confirmationText, setConfirmationText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const CONFIRMATION_TOKEN = React.useMemo(() => {
    return `${release.name}`;
  }, [release.name]);

  async function handleUninstall() {
    try {
      setIsLoading(true);
      await request({
        service: "marketplace",
        method: "post",
        url: `/helm/uninstall`,
        body: {
          org: release.org,
          name: release.name,
        },
      });
      notification.success({ message: "Success", description: "Uninstalled release" });
      setIsLoading(false);
      onDone();
      navigate(`/console/org/${ConsoleContext.org}/marketplace/release`);
    } catch (e) {
      setIsLoading(false);
      const errorMessage = getMarketplaceErrorMessage(e);
      notification.warning({
        message: "Failed",
        description: (
          <div className="flex flex-col gap-2">
            {errorMessage.map((m) => (
              <div>{m}</div>
            ))}
          </div>
        ),
        duration: 20,
      });
    }
  }

  let canDelete = true;
  if (confirmationText !== CONFIRMATION_TOKEN) canDelete = false;

  return (
    <Modal
      title={
        <>
          Uninstall Release:{" "}
          <span className="font-bold" style={{ color: "var(--color-danger)" }}>
            {release.name}
          </span>
        </>
      }
      open={true}
      closable={false}
      maskClosable={!isLoading}
      onCancel={onClose}
      footer={
        <div className="modal-actions">
          <NGButton variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancel
          </NGButton>
          <NGButton variant="danger" onClick={handleUninstall} loading={isLoading} disabled={isLoading || !canDelete}>
            Uninstall
          </NGButton>
        </div>
      }
      destroyOnClose
    >
      <div className="flex flex-col gap-2">
        <div>Are you sure you want to uninstall this release? This action cannot be undone.</div>
        <div className="delete-modal-confirmation-warning mt-4">{`Type "${CONFIRMATION_TOKEN}" for confirming the delete action`}</div>
        <Input
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          placeholder={`confirmation`}
        />
      </div>
    </Modal>
  );
};

export const ReleaseUninstallModal = observer(ReleaseUninstallModalRaw);
